/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {CTCEntity} from '@ion/core/src/types/entities';
import useAddResults from './useAddResults';
import useClonedResults from './useClonedResults';
import useDeleteResults from './useDeleteResults';
import useEditResults from './useEditResults';
import useSwapResults from './useSwapResults';
import useUpdateResults from './useUpdateResults';

// defines the prop definitions for CRUD operation results ...
export type CRUDOperationResults = {
  addResult: CTCEntity | CTCEntity[] | null;
  editResult: CTCEntity | CTCEntity[] | null;
  deleteResult: CTCEntity | CTCEntity[] | null;
  updateResult: CTCEntity | CTCEntity[] | null;
  clonedResult: CTCEntity | CTCEntity[] | null;
  swapResult: CTCEntity | CTCEntity[] | null;
};

/**
 * Provides a utility hook for getting the CRUD operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useCRUDOperationResults} from '@ion/dls/src/hooks/useCRUDOperationResults';
 *   const {
 *     addResult,
 *     editResult,
 *     deleteResult,
 *     updateResult,
 *     clonedResult,
 *     swapResult
 *   } = useCRUDOperationResults('reducer');
 *
 * ```
 */
export const useCRUDOperationResults = (reducer: string): CRUDOperationResults => {
  return {
    addResult    : useAddResults(reducer),
    editResult   : useEditResults(reducer),
    deleteResult : useDeleteResults(reducer),
    updateResult : useUpdateResults(reducer),
    clonedResult : useClonedResults(reducer),
    swapResult   : useSwapResults(reducer)
  };
};

export default useCRUDOperationResults;
